import { Alert } from '@mui/material';
import { useKeycloak } from '@react-keycloak/web';
import { Fragment, useCallback, useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import { translate } from 'react-switch-lang';
import { Button, Card, CardBody, CardHeader, Col, Container, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import { DeleteButtonIcon } from 'src/component/Buttons/DeleteButtonIcon';
import { InfoButtonIcon } from 'src/component/Buttons/InfoButtonIcon';
import SweetAlert from 'sweetalert2';
import { useHttpClient } from '../../../../../security/hooks/axiosProvider';
import Breadcrumb from '../../../breadcrumb';
import styles from '../../../styles/style-setting.module.scss';
import CreateNatureCharge from '../create-nature-charge/create-nature-charge';
import DetailNatureCharge from '../detail-nature-charge/detail-nature-charge';
import EditNatureCharge from '../edit-nature-charge/edit-nature-charge';
import ActivityChargeColumns from './table-header/activity-charge-columns';
const NUMBER_OF_NATURECHARGE_PER_PAGE = 15;

const ListNatureCharge = (props) => {
  const httpClient = useHttpClient(true);
  const [charges, setCharges] = useState([]);
  const [charge, setCharge] = useState({});
  const [pageNumber, setPageNumber] = useState(0);
  const itemPerPage = NUMBER_OF_NATURECHARGE_PER_PAGE;
  const pagesVisited = pageNumber * NUMBER_OF_NATURECHARGE_PER_PAGE;
  const changePage = ({ selected }) => setPageNumber(selected);
  const [role, setRole] = useState('');
  const [search, setSearch] = useState('');
  const [filterByActivity, setFilterByActivity] = useState('');
  const [activities, setActivities] = useState([]);
  const keycloak = useKeycloak().keycloak;
  let data = [];
  const [spinner, setSpinner] = useState({ state: false, id: '' });
  const [modelDetail, setModelDetail] = useState(false);
  const modelDetailToggle = (chargeValue) => {
    setModelDetail(!modelDetail);
    setCharge(chargeValue);
  };
  const pageCount = Math.ceil(
    (search !== ''
      ? charges.filter((charge) => charge.name.includes(search))
      : filterByActivity !== ''
      ? charges.filter((charge) => charge.activity.name.includes(filterByActivity))
      : charges
    ).length / itemPerPage
  );

  const getCharges = useCallback(async () => {
    httpClient.current?.get(`/api/naturecharge/all`).then((response) => {
      const sortedCharges = response.data.sort((a, b) => a.name.localeCompare(b.name));
      setCharges(sortedCharges);
    });
  }, [httpClient]);

  const deleteCharge = async (chargeId) => {
    await httpClient.current?.delete(`/api/naturecharge/${chargeId}`);
    getCharges();
  };

  const handleCheckBox = async (event, charge) => {
    setSpinner({ state: true, id: charge.id });
    const chargeValidation = {
      id: charge.id,
      name: charge.name,
      description: charge.description,
      activity: charge.activity,
      valid: event.target.checked,
    };
    const response = httpClient.current?.put(`/api/naturecharge/update`, chargeValidation);
    if ((await response).status === 200) {
      getCharges();
      setSpinner({ state: false, id: charge.id });
    }
  };

  useEffect(() => {
    const getActivities = () => {
      httpClient.current?.get(`/api/activity/all`).then((response) => {
        setActivities(response.data);
      });
    };
    getActivities();
    getCharges();
    if (keycloak.authenticated) {
      keycloak.hasResourceRole('ROLE_AGRISED_ADMIN_SUPER')
        ? setRole('super admin')
        : keycloak.hasResourceRole('ROLE_AGRISED_ADMIN')
        ? setRole('admin')
        : setRole('user');
    }
  }, [getCharges, httpClient, keycloak]);

  let restPagination = charges
    .filter((charge) => charge.name.toUpperCase().includes(search.toUpperCase()))
    .filter((charge) => charge.activity.name.toUpperCase().includes(filterByActivity.toUpperCase()))
    .slice(pagesVisited, pagesVisited + itemPerPage);

  restPagination.map((charge) => {
    let action = (
      <div>
        <InfoButtonIcon
          onClick={() => modelDetailToggle(charge)}
          title={props.t('more_details')}
          className={`fa fa-eye ${styles['action']}`}
        />
        <span>
          <EditNatureCharge charge={charge} charges={getCharges} />
        </span>
        <span>
          <DeleteButtonIcon
            title={props.t('delete_nc')}
            onClick={() =>
              SweetAlert.fire({
                title: props.t('you_delete'),
                text: props.t('not_recover'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ok',
                cancelButtonText: props.t('cancel'),
                reverseButtons: true,
              }).then((result) => {
                if (result.value) {
                  deleteCharge(charge.id);
                  SweetAlert.fire(props.t('Deleted!'), props.t('isDeleted'), 'success');
                } else {
                  SweetAlert.fire(props.t('isNotDeleted'));
                }
              })
            }
            className={`fa fa-trash ${styles['trash']}`}
          />
        </span>
      </div>
    );
    let status =
      spinner.state === true && spinner.id === charge.id ? (
        <div className={`loader-box  ${styles['spinner']}`}>
          <div className="loader-2"></div>
        </div>
      ) : (
        <input
          type="checkbox"
          disabled={role === 'admin'}
          name="status"
          checked={charge?.valid}
          onChange={(e) => handleCheckBox(e, charge)}
        />
      );
    return data.push({
      id: charge.id,
      name: charge.name,
      description: charge.description,
      status: status,
      action: action,
    });
  });


  return (
    <>
      <div>
        <Fragment>
          <Breadcrumb parent={props.t('activity_charge_url')} url={'settings/nature-charge'} />
          <Container fluid={true}>
            <Row>
              <Col sm="12">
                <Card>
                  <CardHeader>
                    <div className="float-right">
                      <CreateNatureCharge charges={getCharges} />
                    </div>
                  </CardHeader>
                  <CardBody>
                    <div className="row">
                      <div className="col">
                        <input
                          className="form-control mb-2"
                          onChange={(event) => {
                            setSearch(event.target.value);
                            changePage({ selected: 0 });
                          }}
                          value={search}
                          placeholder={props.t('search_unit')}
                        />
                      </div>
                      <div className="col">
                        <select
                          name="activity"
                          id="subActivity_activity"
                          value={filterByActivity}
                          className="form-control mb-2"
                          onChange={(event) => {
                            setFilterByActivity(
                              event.target.value === 'Choose an activity'
                                ? ''
                                : event.target.value === 'Choisissez une activité'
                                ? ''
                                : event.target.value
                            );
                            changePage({ selected: 0 });
                          }}
                        >
                          <option>{props.t('select_activity')}</option>
                          {activities.map((activity) => (
                            <option key={activity.id} value={activity.name}>
                              {activity.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    {data.length === 0 ? (
                      <Alert variant="outlined" severity="info">
                        {props.t('no_nature_charges')}
                      </Alert>
                    ) : (
                      <ActivityChargeColumns data={data} />
                    )}

                    <br />
                    <div className="float-right">
                      {charges.length > NUMBER_OF_NATURECHARGE_PER_PAGE && (
                        <ReactPaginate
                          previousLabel="<"
                          nextLabel=">"
                          pageCount={pageCount}
                          onPageChange={changePage}
                          containerClassName={styles['paginationButton']}
                          previousLinkClassName={styles['previousBtn']}
                          nextLinkClassName={styles['nextBtn']}
                          disabledClassName={styles['paginationDisabled']}
                          activeClassName={styles['paginationActive']}
                        />
                      )}
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </Fragment>
      </div>
      <Modal isOpen={modelDetail} toggle={modelDetailToggle} centered>
        <ModalHeader>{props.t('detail_charge')}</ModalHeader>
        <ModalBody>
          <DetailNatureCharge charge={charge} />
          <div>
            <Button color="secondary" className="float-right" onClick={modelDetailToggle}>
              {props.t('Cancel')}
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default translate(ListNatureCharge);
